export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [8,[2]],
		"/(app)/account": [9,[2]],
		"/(app)/admin/accounts": [10,[2,3]],
		"/(app)/admin/accounts/[account_id]": [11,[2,3]],
		"/(app)/analytics": [12,[2,4]],
		"/(app)/analytics/automation": [13,[2,4]],
		"/(app)/analytics/reports": [14,[2,4]],
		"/(app)/analytics/tasks": [15,[2,4]],
		"/(app)/analytics/validation": [16,[2,4]],
		"/(app)/api": [17,[2]],
		"/(app)/assessments": [18,[2,5]],
		"/(app)/assessments/library": [19,[2,5]],
		"/(app)/assessments/overview": [20,[2,5]],
		"/(dev)/dev/components": [35,[7]],
		"/(dev)/dev/components/[slug]": [36,[7]],
		"/(app)/file-system-agent": [21,[2]],
		"/forbidden": [37],
		"/(app)/isometric-showcase": [22,[2]],
		"/(app)/ops/loanlogics": [23,[2]],
		"/(app)/projects": [24,[2]],
		"/(app)/projects/library": [30,[2]],
		"/(app)/projects/[project_id]": [25,[2,6]],
		"/(app)/projects/[project_id]/about": [26,[2,6]],
		"/(app)/projects/[project_id]/automation": [27,[2,6]],
		"/(app)/projects/[project_id]/configuration": [28,[2,6]],
		"/(app)/projects/[project_id]/validation": [29,[2,6]],
		"/(app)/status": [31,[2]],
		"/(app)/tasks": [32,[2]],
		"/(app)/usage": [33,[2]],
		"/(app)/users": [34,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';